export const GET_PAYMENT_LISTS = 'GET_PAYMENT_LISTS';
export const GET_PAYMENT_POSTBACK = 'GET_PAYMENT_POSTBACK';

export const INIT_STATE = {
	paymentInfo: {},
	searchAgain: false
}


/** WEBPACK FOOTER **
 ** ./src/payment/constants/index.js
 **/